import {
  IonButton,
  IonItem,
  IonList,
  IonPopover,
  IonRadio,
  IonRadioGroup,
  IonRefresher,
  IonRefresherContent,
  IonSkeletonText,
  useIonToast,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonIcon,
  IonContent,
  IonAccordionGroup,
  IonAccordion,
  IonFooter,
  IonLabel,
  IonSearchbar,
  IonInput,
  IonGrid,
  IonCol,
  IonRow,
  IonBackButton,
} from "@ionic/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { CardComponent } from "../components/Cards/StoreCard";
import MyPortal from "../components/MyPortal";
import dayjs from "dayjs";
import { useParams, useHistory } from "react-router-dom";
import SortFunctions from "../components/SortFunctions";
import { useMediaQuery } from "react-responsive";
import {
  funnel as funnelOutline,
  close as closeOutline,
  funnelSharp,
  search as searchOutline,
  arrowBack,
} from "ionicons/icons";

const fields = [
  { label: "TS", dataIndex: "today_amt" },
  { label: "YS", dataIndex: "yesterday_amt" },
  { label: "WTD", dataIndex: "this_week_amt" },
  { label: "MTD", dataIndex: "this_month_amt" },
  { label: "", dataIndex: "ts_last_year_amt" },
  { label: "", dataIndex: "ys_last_year_amt" },
  { label: "", dataIndex: "ws_last_year_amt" },
  { label: "", dataIndex: "ms_last_year_amt" },
  { label: "TSGR%", dataIndex: "today_growth_pct" },
  { label: "YSGR%", dataIndex: "yesterday_growth_pct" },
  { label: "WTDGR%", dataIndex: "week_growth_pct" },
  { label: "MTDGR%", dataIndex: "month_growth_pct" },
];

export default function ETHStoreSummary() {
  const { regionName } = useParams();
  const history = useHistory();
  const ethBase = history.location.pathname.startsWith("/legacy/") ? "/legacy" : "";
  const [details, setDetails] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [present] = useIonToast();

  const [sortState, setSortState] = React.useState({ key: null, direction: null });
  const { handleAscSort, handleDesSort } = SortFunctions({ details, setSortState, setDetails });

  const [masterStoreTypes] = React.useState(["LTL", "PTL", "NEW_STORE"]);
  const [storeTypeFilter, setStoreTypeFilter] = React.useState(null);

  React.useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const s = urlParams.get("storeType");
      if (s) {
        setStoreTypeFilter(s);
        setPendingStoreType(s);
      }
    } catch (err) {
      // ignore
    }
  }, []);

  const [isSortPopoverOpen, setIsSortPopoverOpen] = React.useState(false);
  const [isStoreTypePopoverOpen, setIsStoreTypePopoverOpen] = React.useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isMobileFilterDrawerOpen, setIsMobileFilterDrawerOpen] = React.useState(false);
  const filtersApplied = storeTypeFilter !== null || sortState.key !== null;
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  const [pendingStoreType, setPendingStoreType] = useState(storeTypeFilter ?? "all");
  const [pendingSelectedSortOption, setPendingSelectedSortOption] = useState(selectedSortOption);
  const [pendingSortState, setPendingSortState] = useState(sortState);

  function openMobileFilterDrawer() {
    setPendingStoreType(storeTypeFilter ?? "all");
    setPendingSelectedSortOption(selectedSortOption);
    setPendingSortState(sortState);
    setIsMobileFilterDrawerOpen(true);
  }

  function updateUrlStoreType(value) {
    try {
      const url = new URL(window.location.href);
      if (value === null || value === undefined || value === "all") {
        url.searchParams.delete("storeType");
      } else {
        url.searchParams.set("storeType", value);
      }
      window.history.replaceState({}, "", url.toString());
    } catch (err) {
      console.warn("Failed to update URL storeType param", err);
    }
  }

  function resetPendingToApplied() {
    setPendingStoreType(storeTypeFilter ?? "all");
    setPendingSelectedSortOption(selectedSortOption);
    setPendingSortState(sortState);
  }

  function handleDSort() {
    window.location.reload(true);
  }

  const getData = async (refreshEvent, options = {}) => {
    setLoading(true);
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const localStoreType = urlParams.get("storeType");

      const appliedStoreType = options.hasOwnProperty("storeType")
        ? options.storeType
        : localStoreType || storeTypeFilter;
      const appliedSortState = options.hasOwnProperty("sortState") ? options.sortState : sortState;
      const appliedSearchText = options.hasOwnProperty("searchText") ? options.searchText : searchText;

      const params = {
        summary: "store",
        store_type: appliedStoreType || undefined,
        region: regionName === "All STORES" ? undefined : regionName,
      };

      const res = await axios.get("/ethnicity/get_sales_data", { params });

      const formatToLakh = (value) => (value / 100000).toFixed(2);

      let finalDetails = res.data.data.map((item) => ({
        ...item,
        store_count: item.store_count ?? 0,
        ts_last_year_amt: `${formatToLakh(item.ts_last_year_amt || 0)} `,
        ys_last_year_amt: `${formatToLakh(item.ys_last_year_amt || 0)} `,
        ws_last_year_amt: `${formatToLakh(item.ws_last_year_amt || 0)} `,
        ms_last_year_amt: `${formatToLakh(item.ms_last_year_amt || 0)} `,
      }));

      if (appliedSortState && appliedSortState.key && appliedSortState.direction) {
        finalDetails = [...finalDetails].sort((a, b) => {
          const aVal = a[appliedSortState.key] ?? 0;
          const bVal = b[appliedSortState.key] ?? 0;
          return appliedSortState.direction === "asc" ? aVal - bVal : bVal - aVal;
        });
      }

      const filteredDetails = finalDetails.filter((item) =>
        item.store_name?.toLowerCase().includes((appliedSearchText || "").toLowerCase())
      );

      setDetails([
        finalDetails?.find((item) => item?.store_name === "Ethnicity"),
        ...filteredDetails?.filter((item) => item?.store_name !== "Ethnicity"),
      ]);
    } catch (err) {
      present({
        message: err?.response?.data?.message || "Error Occurred",
        duration: 2000,
        color: "danger",
      });
    }
    setLoading(false);
    refreshEvent?.detail?.complete();
  };

  useEffect(() => {
    getData();
  }, [storeTypeFilter, searchText, regionName]);

  return (
    <div
      style={{
        display: "inline-flex",
        justifyContent: "space-around",
        width: "100%",
        flexWrap: "wrap",
        position: "relative",
        paddingBottom: "50px",
      }}
    >
      <IonRefresher slot="fixed" onIonRefresh={getData}>
        <IonRefresherContent></IonRefresherContent>
      </IonRefresher>

      {loading &&
        !details?.length &&
        Array.from({ length: 10 }).map((_, i) => (
          <IonSkeletonText key={i} animated style={{ height: "150px" }} />
        ))}

      <MyPortal id="navbar-portal-div">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "0 2rem",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              flex: isMobile ? "1 1 auto" : undefined,
              minWidth: 0,
            }}
          >
            {!isMobile && (
              <IonButtons slot="start">
                <IonBackButton
                  defaultHref={`${ethBase}/sales/eth`}
                  text="Back"
                  icon={arrowBack}
                />
              </IonButtons>
            )}
            <div
              style={{
                fontWeight: 500,
                display: "grid",
                fontSize: "1.0rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {decodeURIComponent(regionName)}
              <span style={{ fontSize: "0.8rem", marginTop: "0.2rem" }}>
                {details?.[1]?.updated_at && dayjs(details?.[1]?.updated_at).fromNow()}
              </span>
            </div>
          </div>

          <div style={{ flex: "0 0 auto" }}>
            {isMobile ? (
              <div style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                <IonButton fill="clear" size="small" onClick={() => setIsSearchModalOpen(true)}>
                  <IonIcon icon={searchOutline} />
                </IonButton>
                <IonButton fill="clear" size="small" onClick={openMobileFilterDrawer}>
                  <IonIcon icon={filtersApplied ? funnelSharp : funnelOutline} />
                </IonButton>
                <IonButton fill="clear" size="small" onClick={() => history.goBack()}>
                  <IonIcon icon={arrowBack} />
                </IonButton>
              </div>
            ) : (
              <div style={{ display: "inline-flex", alignItems: "center" }}>
                <div style={{ height: "20px", marginRight: "10px" }}>
                  <IonSearchbar
                    value={searchText}
                    onIonInput={(e) => setSearchText(e.target.value)}
                    placeholder="Search store..."
                    debounce={300}
                  />
                </div>
                <div>
                  <IonButton
                    size="default"
                    color="white"
                    id="popover-eth-store-sort"
                    onClick={() => setIsSortPopoverOpen(!isSortPopoverOpen)}
                  >
                    Sort By
                  </IonButton>
                  <IonButton
                    size="default"
                    color="white"
                    id="popover-eth-storetype"
                    onClick={() => setIsStoreTypePopoverOpen(!isStoreTypePopoverOpen)}
                  >
                    STORE TYPE: {storeTypeFilter ?? "All"}
                  </IonButton>
                </div>
              </div>
            )}
          </div>
        </div>
      </MyPortal>

      <div
        className="cards-container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: isMobile ? "0.5rem" : "1rem",
          padding: isMobile ? "0.5rem" : "1rem",
          width: "100%",
          justifyContent: "center",
        }}
      >
        {(searchText
          ? details.filter((item) => item.store_name !== "Ethnicity")
          : details
        ).map((item, index) => (
          <div
            key={index}
            style={{
              flexBasis: isMobile ? "100%" : "calc(50% - 1rem)",
              maxWidth: isMobile ? "100%" : "400px",
              minWidth: isMobile ? "auto" : "300px",
            }}
          >
            <CardComponent
              data={item}
              fields={fields}
              fieldsInOneRow={4}
              showStoreCountRight={item.store_name === "Ethnicity"}
            />
          </div>
        ))}
      </div>

      {/* Desktop Sort Popover */}
      <IonPopover
        isOpen={isSortPopoverOpen}
        trigger="popover-eth-store-sort"
        keepContentsMounted
        dismissOnSelect={false}
        side="bottom"
        size="auto"
        className="wide-popover"
      >
        <IonContent className="ion-padding">
          <IonAccordionGroup expand="first">
            <IonItem
              button
              onClick={() => {
                setSelectedSortOption("default");
                handleDSort("default");
              }}
            >
              <IonLabel><b>Default</b></IonLabel>
            </IonItem>

            <IonAccordion value="ts">
              <IonItem slot="header"><IonLabel>TS</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "ts_asc") handleAscSort("today_amt");
                    else if (value === "ts_desc") handleDesSort("today_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="ts_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="ts_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="ys">
              <IonItem slot="header"><IonLabel>YS</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "ys_asc") handleAscSort("yesterday_amt");
                    else if (value === "ys_desc") handleDesSort("yesterday_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="ys_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="ys_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="wtds">
              <IonItem slot="header"><IonLabel>WTD</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "wtds_asc") handleAscSort("this_week_amt");
                    else if (value === "wtds_desc") handleDesSort("this_week_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="wtds_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="wtds_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="mtds">
              <IonItem slot="header"><IonLabel>MTD</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "mtds_asc") handleAscSort("this_month_amt");
                    else if (value === "mtds_desc") handleDesSort("this_month_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="mtds_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="mtds_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="obs">
              <IonItem slot="header"><IonLabel>OB</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "obs_asc") handleAscSort("obs_amt");
                    else if (value === "obs_desc") handleDesSort("obs_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="obs_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="obs_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="ebs">
              <IonItem slot="header"><IonLabel>EB</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "ebs_asc") handleAscSort("ebs_amt");
                    else if (value === "ebs_desc") handleDesSort("ebs_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="ebs_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="ebs_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>
          </IonAccordionGroup>
        </IonContent>
      </IonPopover>

      {/* Store Type Popover */}
      <IonPopover
        isOpen={isStoreTypePopoverOpen}
        trigger="popover-eth-storetype"
        keepContentsMounted
        dismissOnSelect
        side="bottom"
        size="auto"
      >
        <IonList>
          <IonRadioGroup
            value={storeTypeFilter ?? "all"}
            onIonChange={(e) => {
              const val = e.detail.value;
              const applied = val === "all" ? null : val;
              setStoreTypeFilter(applied);
              updateUrlStoreType(applied);
              setIsStoreTypePopoverOpen(false);
            }}
          >
            <IonItem><IonLabel>All Store Types</IonLabel><IonRadio slot="end" value="all" /></IonItem>
            {masterStoreTypes.map((type) => (
              <IonItem key={type}>
                <IonLabel>{type}</IonLabel>
                <IonRadio slot="end" value={type} />
              </IonItem>
            ))}
          </IonRadioGroup>
        </IonList>
      </IonPopover>

      {/* Mobile Search Modal */}
      <IonModal isOpen={isSearchModalOpen} onDidDismiss={() => setIsSearchModalOpen(false)}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Search Store</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setIsSearchModalOpen(false)}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonItem>
            <IonIcon icon={searchOutline} slot="start" />
            <IonInput
              type="text"
              value={searchText}
              placeholder="Search store name..."
              onIonInput={(e) => setSearchText(e.target.value)}
              clearInput
            />
          </IonItem>
          <IonGrid>
            <IonRow>
              <IonCol size="6">
                <IonButton expand="block" onClick={() => setIsSearchModalOpen(false)}>
                  Search
                </IonButton>
              </IonCol>
              <IonCol size="6">
                <IonButton
                  expand="block"
                  fill="outline"
                  color="medium"
                  onClick={() => {
                    setSearchText("");
                    setIsSearchModalOpen(false);
                  }}
                >
                  Clear
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonModal>

      {/* Mobile Filter Drawer */}
      <IonModal
        isOpen={isMobileFilterDrawerOpen}
        onDidDismiss={() => {
          setIsMobileFilterDrawerOpen(false);
          resetPendingToApplied();
        }}
        className="mobile-filter-modal"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filters</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonAccordionGroup expand="first">
            <IonAccordion value="storetype">
              <IonItem slot="header"><IonLabel>Store Type</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={pendingStoreType ?? "all"}
                  onIonChange={(e) => setPendingStoreType(e.detail.value)}
                >
                  <IonItem><IonLabel>All Store Types</IonLabel><IonRadio slot="end" value="all" /></IonItem>
                  {masterStoreTypes.map((type) => (
                    <IonItem key={type}>
                      <IonLabel>{type}</IonLabel>
                      <IonRadio slot="end" value={type} />
                    </IonItem>
                  ))}
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="sort">
              <IonItem slot="header"><b>Sort By</b></IonItem>
              <div className="ion-padding" slot="content">
                <IonAccordionGroup expand="inset">
                  <IonItem
                    button
                    onClick={() => {
                      setPendingSelectedSortOption("default");
                      setPendingSortState({ key: null, direction: null });
                    }}
                  >
                    Default
                  </IonItem>

                  {[
                    { key: "ts", label: "TS", field: "today_amt", asc: "ts_asc", desc: "ts_desc" },
                    { key: "ys", label: "YS", field: "yesterday_amt", asc: "ys_asc", desc: "ys_desc" },
                    { key: "ws", label: "WTDS", field: "this_week_amt", asc: "wtds_asc", desc: "wtds_desc" },
                    { key: "ms", label: "MTDS", field: "this_month_amt", asc: "mtds_asc", desc: "mtds_desc" },
                    { key: "obs", label: "OB", field: "obs_amt", asc: "obs_asc", desc: "obs_desc" },
                    { key: "ebs", label: "EB", field: "ebs_amt", asc: "ebs_asc", desc: "ebs_desc" },
                  ].map((sort) => (
                    <IonAccordion key={sort.key} value={sort.key}>
                      <IonItem slot="header"><IonLabel>{sort.label}</IonLabel></IonItem>
                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={pendingSelectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setPendingSelectedSortOption(value);
                            if (value === sort.asc) setPendingSortState({ key: sort.field, direction: "asc" });
                            else if (value === sort.desc) setPendingSortState({ key: sort.field, direction: "desc" });
                          }}
                        >
                          <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value={sort.asc} /></IonItem>
                          <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value={sort.desc} /></IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>
                  ))}
                </IonAccordionGroup>
              </div>
            </IonAccordion>
          </IonAccordionGroup>
        </IonContent>
        <IonFooter>
          <IonToolbar>
            <div style={{ display: "flex", gap: "0.5rem", padding: "0.5rem", width: "100%" }}>
              <div style={{ flex: 1 }}>
                <IonButton
                  expand="block"
                  fill="outline"
                  color="medium"
                  onClick={async () => {
                    setPendingStoreType("all");
                    setPendingSelectedSortOption(null);
                    setPendingSortState({ key: null, direction: null });
                    setStoreTypeFilter(null);
                    setSelectedSortOption(null);
                    setSortState({ key: null, direction: null });
                    setIsMobileFilterDrawerOpen(false);
                    updateUrlStoreType(null);
                    await getData(null, { storeType: null, sortState: { key: null, direction: null } });
                  }}
                >
                  Clear
                </IonButton>
              </div>
              <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                <div style={{ width: "160px" }}>
                  <IonButton
                    expand="block"
                    onClick={async () => {
                      const appliedStore = pendingStoreType === "all" ? null : pendingStoreType;
                      setStoreTypeFilter(appliedStore);
                      setSelectedSortOption(pendingSelectedSortOption);
                      setSortState(pendingSortState);
                      setIsMobileFilterDrawerOpen(false);
                      updateUrlStoreType(appliedStore);
                      await getData(null, { storeType: appliedStore, sortState: pendingSortState });
                    }}
                  >
                    Apply
                  </IonButton>
                </div>
              </div>
            </div>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </div>
  );
}
